import { GET_ACTIVE_FARMS_BY_ORG_API_URL } from 'constants/Constant';
import { IFarm } from 'interfaces/IFarm';
import axiosInstance from 'services/AxiosInstance';

export const FarmService = {
  /**
   * Fetches all farms for a specific organization.
   *
   * Reads GetByOrgActive, so soft-deleted farms and their paddocks are
   * excluded server-side — the client does no filtering of its own.
   *
   * @param orgId - The organization ID to fetch farms for
   * @returns Promise containing an array of active farms and their paddocks
   */
  GetByOrgActive: async (orgId: string): Promise<IFarm[]> => {
    const response = await axiosInstance.get<IFarm[]>(
      `${GET_ACTIVE_FARMS_BY_ORG_API_URL}/${orgId}`,
      { _silentErrors: true }
    );
    return response.data;
  },
};

export default FarmService;
